var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","height":"480","width":"640","viewBox":"0 0 640 480"}},[_c('path',{attrs:{"fill":"#ffce00","d":"M0 320h640v160.002H0z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000000","d":"M0 0h640v160H0z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#d00","d":"M0 160h640v160H0z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40fcdf9c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/flags/de_de.vue
// module id = 1116
// module chunks = 0